module.exports = __webpack_public_path__ + "media/stylesheets/images/media/service_belcy-3fe2266e62a22629202a629ed536051a.png";